import { create } from 'zustand';

const useCardModal = create((set) => ({
  activeIndex: 0,
  rangeFinder: 3,
  setActive: (id) => set({ activeIndex: id }),
}))

export default useCardModal;